import { historyApi } from "@api";
import { ComponentPopUpDone, CouponImage, ModuleEmpty } from "@components";
import { INITIAL_LIST_PARAMS, enumTypes } from "@configs";
import {
    IBenefit,
    ICoupon,
    IFreePoint,
    IMerchantFreePoint,
    IPagination,
    IReward,
} from "@interfaces";
import { resetConfirm, selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { HistoryEmptyIcon } from "src/Components/icon/HistoryEmptyIcon";
import { formatDateNumber } from "src/Utils/dateUtil";
import styled from "styled-components";

export const ModuleHistory = () => {
    //page hooks
    const dispatch = useDispatch();
    const { t } = useTranslation();
    //page state
    const [histories, setHistories] = useState<(IBenefit | IReward | ICoupon | IFreePoint)[]>([]);
    const [currenHistory, setCurrenHistory] = useState<{
        data: IBenefit | IReward | ICoupon | IFreePoint | IMerchantFreePoint;
        point: number | undefined;
    }>();
    const [loadingPagination, setLoadingPagination] = useState<boolean>(false);
    const [param, setParam] = useState<IPagination>(INITIAL_LIST_PARAMS);
    const [spinning, setSpinning] = useState<boolean>(false);
    const [historyList, setHistoryList] = useState<any[]>([]);
    const { themes } = useSelector(selectMerchant);
    const themeColor = themes?.themeColor || "#FF5B00";
    const today = new Date();
    const [currentHistory, setCurrentHistory] = useState<any>();
    const [showHistoryQr, setShowHistoryQr] = useState<boolean>(false);
    const [filterType, setFilterType] = useState<string>("REDEEMED");

    useEffect(() => {
        getInitData();
        dispatch(resetConfirm());
    }, [filterType]);

    const getInitData = async () => {
        setSpinning(true);
        let res = await historyApi.gethistories(filterType);
        setHistoryList(res.data);
        // await handleGetData(param);
        setSpinning(false);
    };

    const handleGetData = async (param: IPagination) => {
        const res = await historyApi.getListHistory(param);
        const data = res.data?.docs?.map((item: any) => {
            //WHAT: Nếu type = reward thi as data = dataReward
            if (item.type === enumTypes.REWARD) {
                return {
                    exchangedType: item.exchangedType,
                    idCart: item._id,
                    updatedAtHistory: item.updatedAt,
                    quantityPoint: item.quantity,
                    ...item.reward,
                    point: item.points,
                    ticketCode: item.ticketCode,
                    notiStatus: item.notiStatus,
                    note: item.note,
                };
            }
            //WHAT: Nếu type = benefit thi as data = dataBenefit
            else if (item.type === enumTypes.BENEFIT) {
                return {
                    exchangedType: item.exchangedType,
                    idCart: item._id,
                    updatedAtHistory: item.updatedAt,
                    notiStatus: item.notiStatus,
                    ticketCode: item.ticketCode,
                    note: item.note,
                    ...item.reward,
                };
            }
            //WHAT: Nếu type = COUPON thi as data = dataCOUPON, data coupon giống FREE_POINT
            else if (item.type === enumTypes.COUPON || item.type === enumTypes.FREE_POINT) {
                return {
                    exchangedType: item.exchangedType,
                    idCart: item._id,
                    updatedAtHistory: item.updatedAt,
                    ticketCode: item.ticketCode,
                    notiStatus: item.notiStatus,
                    alienCode: item.alienCode,
                    note: item.note,
                    ...item.qrtable,
                };
            } else {
                return item;
            }
        }) as (IBenefit | IReward | ICoupon | IFreePoint)[];
        const filterHistory = data.filter((history) => history.notiStatus !== undefined);

        setHistories([...histories, ...filterHistory]);
    };

    const handleLoadMore = async () => {
        const paramPanigation = {
            ...param,
            page: (param.page || 1) + 1,
        };
        setParam(paramPanigation);
        setLoadingPagination(true);
        await handleGetData(paramPanigation);
        setLoadingPagination(false);
    };

    const loadingComponent = (
        <StyledSkeleton>
            <Skeleton
                loading={true}
                active
                title={false}
                paragraph={{ rows: 3, width: [172, 220, 92] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                active
                title={false}
                paragraph={{ rows: 3, width: [172, 220, 92] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                active
                title={false}
                paragraph={{ rows: 3, width: [172, 220, 92] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                active
                title={false}
                paragraph={{ rows: 3, width: [172, 220, 92] }}
            ></Skeleton>
        </StyledSkeleton>
    );

    const clickRedemption = (data: any) => {
        // click histroy item
        if (data?.type === "COUPON") {
            let arr = {
                ...data?.qrtable,
                ticketCode: data?.ticketCode,
                alienCode: data?.alienCode,
                notiStatus: data?.notiStatus,
                autoUseTime: data?.autoUseTime,
                autoUseTimeOut: data?.autoUseTimeOut,
            };
            setCurrentHistory(arr);
        } else {
            setCurrentHistory(data);
        }
        // if (data?.type === "COUPON" && data?.exchangedType === "RECEIVED") {
        //     setShowPopup(true);
        //     setShowPopupPage(true);
        //     setShowPage1(true);
        // } else {
        //     setShowHistoryQr(true);
        // }
        setShowHistoryQr(true);
    };

    return (
        <>
            <RenderMeta title={t("meta.history_list")} />
            <StyledFilterByType>
                <StyledBtnPurchases
                    themeColor={themeColor}
                    isActive={filterType === "REDEEMED"}
                    onClick={() => setFilterType("REDEEMED")}
                >
                    {t("page.redeem")}
                </StyledBtnPurchases>
                <StyledBtnPurchases
                    themeColor={themeColor}
                    onClick={() => setFilterType("USED")}
                    isActive={filterType === "USED"}
                >
                    {t("page.history_redeem.RESOLVED")}
                </StyledBtnPurchases>
                <StyledBtnPurchases
                    themeColor={themeColor}
                    onClick={() => setFilterType("EXPIRED")}
                    isActive={filterType === "EXPIRED"}
                >
                    {t("page.history_redeem.expired")}
                </StyledBtnPurchases>
            </StyledFilterByType>
            {!spinning ? (
                historyList.length > 0 ? (
                    <>
                        {historyList?.map((hItem: any, hIndex: number) => {
                            let expireDate =
                                hItem?.type === "COUPON"
                                    ? new Date(hItem?.qrtable?.endDate)
                                    : new Date(hItem?.endDate);
                            const isExpired = expireDate && expireDate < today;
                            return (
                                <>
                                    <StyledContainerReward
                                        themeColor={themes?.themeColor!}
                                        key={hIndex}
                                        onClick={() => clickRedemption(hItem)}
                                    >
                                        <div className="img-layout">
                                            <CouponImage
                                                imageUrl={
                                                    (hItem?.type === "COUPON"
                                                        ? hItem?.qrtable?.imageUrl?.[0]
                                                        : hItem?.imageUrl?.[0]) ||
                                                    "images/img-historyredeem-02.svg"
                                                }
                                                grayScale={
                                                    hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? true
                                                            : false
                                                        : true
                                                }
                                            />
                                            <div className="used" />
                                        </div>
                                        <div className="body">
                                            <div>
                                                <div className="type">
                                                    {t("page.history_redeem." + hItem?.type)}
                                                </div>
                                                <div className="title text-sub-header">
                                                    {hItem?.type === "COUPON"
                                                        ? hItem?.qrtable?.name
                                                        : hItem?.name}
                                                </div>
                                            </div>
                                            <div className="date">
                                                <span className="status by">
                                                    {/* {hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? t("page.history_redeem.expired")
                                                            : t(
                                                                "page.history_redeem." +
                                                                hItem?.notiStatus
                                                            )
                                                        : t(
                                                            "page.history_redeem." +
                                                            hItem?.notiStatus
                                                        )} */}
                                                    T&C
                                                </span>
                                                <span className="time eng">
                                                    {/* {hItem?.notiStatus !== "RESOLVED"
                                                    ? isExpired
                                                        ? `${t("page.history_redeem.expired")}`
                                                        : `${t(("page.history_redeem." + hItem?.notiStatus))} ${formatDate(hItem?.qrtable?.endDate)}`
                                                    : t("page.history_redeem." + hItem?.notiStatus)
                                                } */}
                                                    {hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? `${t(
                                                                  "page.exp"
                                                              )} : ${formatDateNumber(
                                                                  hItem?.endDate
                                                              )}`
                                                            : `Redeemed : ${formatDateNumber(
                                                                  hItem?.createdAt
                                                              )}`
                                                        : `Used : ${formatDateNumber(
                                                              hItem?.updatedAt
                                                          )}`}
                                                    {hItem?.notiStatus !== "RESOLVED" ? (
                                                        isExpired ? (
                                                            <span className="absolute expireDate">
                                                                Expire
                                                            </span>
                                                        ) : (
                                                            <span className="absolute leftDate">
                                                                Left{" "}
                                                                {Math.ceil(
                                                                    (new Date(
                                                                        hItem?.type === "COUPON"
                                                                            ? hItem?.qrtable
                                                                                  ?.endDate
                                                                            : hItem?.endDate
                                                                    ).getTime() -
                                                                        new Date().getTime()) /
                                                                        (1000 * 3600 * 24)
                                                                )}{" "}
                                                                days
                                                            </span>
                                                        )
                                                    ) : (
                                                        ""
                                                    )}
                                                    {/* {t("page.history_redeem.expired")} :{" "} */}
                                                    {/* {hItem?.type === "COUPON"
                                                    ? formatDate(hItem?.qrtable?.endDate)
                                                    : formatDate(hItem?.endDate)} */}
                                                    {/* {hItem?.type === "COUPON" &&
                                                        formatDateNumber(hItem?.qrtable?.endDate)} */}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="quality">
                                            <StyledBtnPurchases
                                                // themeColor={themes?.themeColor!}
                                                themeColor={
                                                    hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? "gray"
                                                            : themeColor
                                                        : themeColor
                                                }
                                                isActive={
                                                    hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? false
                                                            : true
                                                        : true
                                                }
                                                className={
                                                    hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? "display-none"
                                                            : ""
                                                        : "disable-btn"
                                                }
                                                disabled={
                                                    hItem?.notiStatus !== "RESOLVED"
                                                        ? isExpired
                                                            ? true
                                                            : false
                                                        : true
                                                }
                                            >
                                                {hItem?.notiStatus !== "RESOLVED"
                                                    ? isExpired
                                                        ? t("page.history_redeem.expired")
                                                        : t(
                                                              "page.history_redeem." +
                                                                  hItem?.notiStatus +
                                                                  "_next"
                                                          )
                                                    : t(
                                                          "page.history_redeem." +
                                                              hItem?.notiStatus +
                                                              "_next"
                                                      )}
                                                {/* {t("page.history_redeem." + hItem?.notiStatus + "_next")} */}
                                            </StyledBtnPurchases>
                                        </div>
                                    </StyledContainerReward>
                                </>
                            );
                        })}
                    </>
                ) : (
                    <div style={{ height: "500px" }}>
                        <StyledEmptyLayout>
                            <ModuleEmpty
                                description={t("page.no_history")}
                                image={<HistoryEmptyIcon />}
                            />
                        </StyledEmptyLayout>
                    </div>
                )
            ) : (
                loadingComponent
            )}
            {showHistoryQr && (
                <ComponentPopUpDone
                    handleCloseDetail={() => setShowHistoryQr(false)}
                    data={currentHistory}
                />
            )}
        </>
    );
};

const StyledSkeleton = styled.div`
    display: grid;
    padding: 12px;
    .ant-skeleton {
        display: flex;
        background-color: #e8e8e8;
        padding: 12px;
        border-radius: 14px;
        width: 100%;
        margin-bottom: 8px;
        flex-direction: column;
        .ant-skeleton-paragraph {
            margin-top: 0 !important;
            margin-bottom: 15px;
            li {
                height: 10px;
                border-radius: 4px;
                margin-top: 8px;
            }
        }
    }
`;

const StyledLoading = styled.div`
    margin: 25px 24px 0 24px;
    .card {
        margin-bottom: 16px;
        padding: 18px 14px;
        background-color: ${(p) => p.theme.colors.card};
        box-shadow: 1px 3px 6px rgba(0, 0, 0, 0.16), 1px 3px 6px rgba(0, 0, 0, 0.23);
        border-radius: 6px;
    }
`;
const StyledEmptyLayout = styled.div`
    .ant-empty-description {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #a5a5a5;
    }
`;

const StyledContainerReward = styled.div<{ themeColor: string }>`
    display: flex;
    justify-content: space-between;
    background: ${(p) => p.theme.colors.card};
    cursor: pointer;
    border-radius: 15px;
    /* margin-bottom: 10px; */
    height: auto;
    /* padding: 0 16px; */
    position: relative;
    padding-right: 70px;
    margin: 10px;
    p {
        margin: 0;
    }
    .status.by {
        color: #001cdb !important;
        font-weight: 600;
    }
    .absolute {
        position: absolute !important;
        top: -5px;
        border-radius: 5px;
        padding: 4px 8px;
        margin-left: 10px;
    }
    .expireDate {
        background-color: #cccccc;
        color: #919191;
    }
    .leftDate {
        background-color: #ffdddb;
        color: #eb4c3e;
    }
    .img-layout {
        /* flex: 1.5; */
        position: relative;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
        background-color: ${(p) => p.themeColor};
        overflow: hidden;
        width: 105px;
        .status {
            padding: 4px 8px;
            background: #676767;
            border-radius: 4px;
            position: absolute;
            top: 3px;
            left: -9px;
            z-index: 1;
            color: #fff;
            &.active {
                background: #49c549;
            }
            span {
                font-weight: 500;
                font-size: 10px;
                line-height: 16px;
                text-align: right;
                /* background: ${(p) => p.theme.colors.card}; */
                background: transparent;
            }
        }
        .used {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
            background: ${(p) => p.theme.colors.card};
            opacity: 0.4;
        }
    }
    .body {
        flex: 3;
        padding: 16px 12px 16px 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .type {
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: #525257;
            margin-bottom: 5px;
        }

        .title {
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            color: ${(p) => p.theme.colors.color};
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            padding-bottom: 3px;
            width: 200px;
            word-wrap: break-word;
        }
        .date {
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 14px;
            color: #919191;
            white-space: nowrap;
            span {
                position: relative;
                margin-right: 5px;
                padding-right: 5px;
                &:after {
                    content: "";
                    width: 1px;
                    height: 12px;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    background-color: #919191;
                    transform: translateY(-50%);
                }
                &:last-child {
                    &:after {
                        display: none;
                        margin-right: 0;
                        padding-right: 0;
                    }
                }
            }
            .approve {
                color: #007e3a;
            }
            .reject {
                color: #d20006;
            }
        }
    }
    .quality {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: end;
        padding: 12px;
        justify-content: space-between;
        border-right-top-radius: 14px;
        border-right-bottom-radius: 14px;
        overflow: hidden;
        position: absolute;
        right: 0;
        top: 0;
        p {
            margin: 0;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            text-align: right;
            color: #e53223;
        }
        .disable-btn {
            background-color: #a9a9a9;
            border-color: #a9a9a9;
        }
        .display-none {
            display: none;
        }
    }
    .add {
        p {
            color: #26c2a4;
        }
    }
`;
const StyledBtnPurchases = styled.button<{ themeColor: string; isActive?: boolean }>`
    padding: 6px 12px;
    color: #000;
    border-radius: 8px;
    border: 0.5px solid #f0f0f0;
    cursor: pointer;
    font-size: 12px;
    line-height: 16px;
    background: ${(p) => (p.isActive ? p.themeColor : "")};
    color: ${(p) => (p.isActive ? "#fff" : p.theme.colors.color)};
    border: 0.5px solid ${(p) => (p.isActive ? p.themeColor : "#f0f0f0")};
    /* &:active {
    } */
`;

const StyledFilterByType = styled.div`
    display: flex;
    gap: 10px;
    padding: 0px 10px 20px 10px;
`;
